import { render, staticRenderFns } from "./IndexOFP.vue?vue&type=template&id=9816bb06&scoped=true"
import script from "./IndexOFP.vue?vue&type=script&lang=js"
export * from "./IndexOFP.vue?vue&type=script&lang=js"
import style0 from "./IndexOFP.vue?vue&type=style&index=0&id=9816bb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9816bb06",
  null
  
)

export default component.exports